import React from 'react';
import Util from '../Util';

class SosdbKiosk extends React.Component {
  render() {
    let hostInfo = this.props.hostInfo;
    let sosdbKiosk = hostInfo.sosdbKiosk || {};
    let lastFullSync = Util.localDateTimeString(sosdbKiosk.lastFullSync);
    let deployDate = Util.localDateTimeString(sosdbKiosk.deployDate);

    return (
      <div
        className='pure-g pure-p pure-u-1'
        style={{ position: 'relative', backgroundColor: 'white', paddingTop: 30, marginBottom: 10 }}
      >
        <div style={{ position: 'absolute', top: 0, left: 0 }}>
          <div className='box-info'>ADM</div>
        </div>

        <div className='info-card pure-u-6-24'>
          <span>Kiosk Name:</span>
          {sosdbKiosk.name}
          {sosdbKiosk.type && <i style={{ fontSize: 12 }}>(type: {sosdbKiosk.type})</i>}
          <div style={{ fontSize: 12 }}>{sosdbKiosk.id}</div>
        </div>
        <div className='info-card pure-u-12-24'>
          <span>Location:</span>
          <div>{sosdbKiosk.locName}</div>
          <div style={{ fontSize: 12 }}>{sosdbKiosk.location}</div>
        </div>
        <div className='info-card pure-u-6-24'>
          <span>Org:</span>
          <div>{sosdbKiosk.orgName}</div>
          <div style={{ fontSize: 12 }}>{sosdbKiosk.org}</div>
        </div>

        <div className='info-card pure-u-6-24'>
          <span>TerminalId 1:</span>
          <div>{sosdbKiosk.terminalid}</div>
        </div>
        <div className='info-card pure-u-3-24'>
          <span>Processor 1:</span>
          <div>{sosdbKiosk.processor1}</div>
        </div>
        <div className='info-card pure-u-12-24'>
          <span>TerminalId 2:</span>
          <div>{sosdbKiosk.terminalid2}</div>
        </div>
        <div className='info-card pure-u-3-24'>
          <span>Processor 2:</span>
          <div>{sosdbKiosk.processor2}</div>
        </div>

        <div className='info-card pure-u-4-24'>
          <span>Status:</span>
          <div>{hostInfo.sosdbKioskStatus}</div>
        </div>
        <div className='info-card pure-u-4-24'>
          <span>Monitor:</span>
          <div>{hostInfo.sosdbMonitor === 0 ? 'Disabled' : 'Enabled'}</div>
        </div>
        <div className='info-card pure-u-6-24'>
          <span>Deployment Set:</span>
          <div>{hostInfo.sosdbDeploymentSet}</div>
        </div>
        <div className='info-card pure-u-4-24'>
          <span>Update Time:</span>
          <div>{hostInfo.sosdbDeploymentTime}</div>
        </div>
        <div className='info-card pure-u-6-24'>
          <span>Serial Number:</span>
          <div>{sosdbKiosk.serialNumber}</div>
        </div>

        <div className='info-card pure-u-6-24'>
          <span>Description:</span>
          <div>{sosdbKiosk.description}</div>
        </div>
        <div className='info-card pure-u-6-24'>
          <span>Notes:</span>
          <div>{sosdbKiosk.notes}</div>
        </div>
        <div className='info-card pure-u-6-24'>
          <span>Last FullSync:</span>
          <div>{lastFullSync}</div>
        </div>
        <div className='info-card pure-u-6-24'>
          <span>Deploy Date:</span>
          <div>{deployDate}</div>
        </div>
        {/*
        <pre>
          {JSON.stringify(sosdbKiosk, undefined, 2)}
        </pre>
*/}
      </div>
    );
  }
}

export default SosdbKiosk;



// WEBPACK FOOTER //
// ./src/components/SosdbKiosk.js